import "./HelpCenterLayout.scss"

import { ReactNode } from "react"

interface HelpCenterLayoutProps {
  sidebar: ReactNode
  children: ReactNode
}

function HelpCenterLayout(props: HelpCenterLayoutProps) {
  return (
    <div className="help-center-layout">
      <div className="help-center-layout__sidebar">{props.sidebar}</div>
      <div className="help-center-layout__content">{props.children}</div>
    </div>
  )
}

export default HelpCenterLayout
